<template>
    <p class="m-0 small text-lowercase">{{ days }}d {{ hours }}h {{ minutes }}m {{ seconds }}s</p>
</template>

<script>
    export default {
        props: {
            endDate: {
                type: String
            }
        },
        data() { 
            return {
                days: null,
                hours: null,
                minutes: null,
                seconds: null
            }
        },
        methods: {
            updateRemaining(distance) {
                this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
                this.days = ('0' + this.days).slice(-2)
                this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                this.hours = ('0' + this.hours).slice(-2)
                this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
                this.minutes = ('0' + this.minutes).slice(-2)
                this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
                this.seconds = ('0' + this.seconds).slice(-2)
            },
            tick() {
                const currentTime = new Date()
                const endDate_formatted = new Date(Date.parse(this.endDate));

                const distance = Math.max(endDate_formatted - currentTime, 0)
                this.updateRemaining(distance)
      
                if (distance === 0) {
                    clearInterval(this.timer)
                    if (Date.now() >= endDate_formatted) {
                        this.$emit('close');
                    }
                }
            },
        },
        mounted() {
            this.tick()
            this.timer = setInterval(this.tick.bind(this), 1000)
        },
        destroy() {
            clearInterval(this.timer)
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
        }
    }
</script>